<template>
  <b-form-group
    :label="label"
    :label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      :name="name"
      :rules="validate"
    >
     <div :class="customClass"><input
        :autocomplete="name"
         autosave
        :id="id"
        :disabled="disabled"
        :type="type"
        :class="['form-control', { 'is-invalid': errors.length > 0 }]"
        :value="value"
        :max="max"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      ></div>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
export default {
  props: {
    label: {
      default: '',
      type: String
    },
    name: {
      default: '',
      type: String
    },
    type: {
      default: 'text'
    },
    id: {
      default: '',
      type: String
    },
    validate: {
      default: '',
      required: false
    },
    value: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    disabled: {
      default: false
    },
    customClass: {
      default: '',
      type: String
    },
    max: {
      default: '',
      type: String
    }
  },
  methods: {
    test (t, y) {
      console.log(t, y)
    }
  }
}
</script>
